import Isotope from 'isotope-layout';
// import videojs from 'video.js'

export default {
  init() {

    var $grid = new Isotope('.home-tiles', {
      resizable: true,
      itemSelector: '.tile',
      layoutMode: 'fitRows',
      transitionDuration: '0.8s',

      hiddenStyle: {
        transform: 'scale(0.5)',
        opacity: 0,
      },
      visibleStyle: {
        transform: 'scale(1)',
        opacity: 1,
      },
      percentPosition: true,
      fitRows: {
        gutter: '.gutter-sizer',
      },
    });

    $('.interests').find('.upper').each(function () {
      $(this).bind('click', function () {
        var filterValue = $(this).attr('data-filter');

        if ($(this).hasClass('active')) {
          $(this).removeClass('active');
          $grid.arrange({
            filter: null,
          });
        } else {
          $('.interests').find('.active').removeClass('active');
          $(this).addClass('active');
          $grid.arrange({
            filter: filterValue,
          });
        }
      });
    });
  },

  finalize() {

    $('.carousel-content').slick({
      appendDots: '.carousel-nav',
      dots: true,
      autoplay: true,
      autoplaySpeed: 3500,
      easing: 'ease-out',
      speed: 600,
      adaptiveHeight: true,
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js